module.exports = __webpack_public_path__ + "img/auntbettys-img.8e2210ec.jpg";